/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * chain | interactive.
 */
export const UpdateOrganizationUserSessionIssuerFormAuthnChallengeMode = {
  Chain: "chain",
  Interactive: "interactive",
} as const;
/**
 * chain | interactive.
 */
export type UpdateOrganizationUserSessionIssuerFormAuthnChallengeMode =
  ClosedEnum<typeof UpdateOrganizationUserSessionIssuerFormAuthnChallengeMode>;

/**
 * Which CIMD (OAuth Client ID Metadata Document) clients this issuer admits. 'presets' admits Speakeasy's curated catalog plus this issuer's custom URLs; 'open' admits any spec-valid document; 'disabled' admits none and stops advertising CIMD support. Omit to leave unchanged.
 */
export const UpdateOrganizationUserSessionIssuerFormClientIdMetadataAdmissionMode =
  {
    Disabled: "disabled",
    Presets: "presets",
    Open: "open",
  } as const;
/**
 * Which CIMD (OAuth Client ID Metadata Document) clients this issuer admits. 'presets' admits Speakeasy's curated catalog plus this issuer's custom URLs; 'open' admits any spec-valid document; 'disabled' admits none and stops advertising CIMD support. Omit to leave unchanged.
 */
export type UpdateOrganizationUserSessionIssuerFormClientIdMetadataAdmissionMode =
  ClosedEnum<
    typeof UpdateOrganizationUserSessionIssuerFormClientIdMetadataAdmissionMode
  >;

/**
 * Form for updating an organization-owned user_session_issuer. All non-id fields are optional patches.
 */
export type UpdateOrganizationUserSessionIssuerForm = {
  /**
   * chain | interactive.
   */
  authnChallengeMode?:
    | UpdateOrganizationUserSessionIssuerFormAuthnChallengeMode
    | undefined;
  /**
   * Which CIMD (OAuth Client ID Metadata Document) clients this issuer admits. 'presets' admits Speakeasy's curated catalog plus this issuer's custom URLs; 'open' admits any spec-valid document; 'disabled' admits none and stops advertising CIMD support. Omit to leave unchanged.
   */
  clientIdMetadataAdmissionMode?:
    | UpdateOrganizationUserSessionIssuerFormClientIdMetadataAdmissionMode
    | undefined;
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * Maximum issued user session lifetime, in hours.
   */
  sessionDurationHours?: number | undefined;
  /**
   * Rename the slug.
   */
  slug?: string | undefined;
  /**
   * Organization-level remote_session_client Speakeasy uses with the trusted issuer. Omit to leave unchanged; pass an empty string to clear the link. The resulting issuer and client must either both be configured or both be absent.
   */
  trustedRemoteSessionClientId?: string | undefined;
  /**
   * Organization-level or global remote_session_issuer whose assertions this issuer trusts. Omit to leave unchanged; pass an empty string to clear the link.
   */
  trustedRemoteSessionIssuerId?: string | undefined;
};

/** @internal */
export const UpdateOrganizationUserSessionIssuerFormAuthnChallengeMode$outboundSchema:
  z.ZodMiniEnum<
    typeof UpdateOrganizationUserSessionIssuerFormAuthnChallengeMode
  > = z.enum(UpdateOrganizationUserSessionIssuerFormAuthnChallengeMode);

/** @internal */
export const UpdateOrganizationUserSessionIssuerFormClientIdMetadataAdmissionMode$outboundSchema:
  z.ZodMiniEnum<
    typeof UpdateOrganizationUserSessionIssuerFormClientIdMetadataAdmissionMode
  > = z.enum(
    UpdateOrganizationUserSessionIssuerFormClientIdMetadataAdmissionMode,
  );

/** @internal */
export type UpdateOrganizationUserSessionIssuerForm$Outbound = {
  authn_challenge_mode?: string | undefined;
  client_id_metadata_admission_mode?: string | undefined;
  id: string;
  session_duration_hours?: number | undefined;
  slug?: string | undefined;
  trusted_remote_session_client_id?: string | undefined;
  trusted_remote_session_issuer_id?: string | undefined;
};

/** @internal */
export const UpdateOrganizationUserSessionIssuerForm$outboundSchema:
  z.ZodMiniType<
    UpdateOrganizationUserSessionIssuerForm$Outbound,
    UpdateOrganizationUserSessionIssuerForm
  > = z.pipe(
    z.object({
      authnChallengeMode: z.optional(
        UpdateOrganizationUserSessionIssuerFormAuthnChallengeMode$outboundSchema,
      ),
      clientIdMetadataAdmissionMode: z.optional(
        UpdateOrganizationUserSessionIssuerFormClientIdMetadataAdmissionMode$outboundSchema,
      ),
      id: z.string(),
      sessionDurationHours: z.optional(z.int()),
      slug: z.optional(z.string()),
      trustedRemoteSessionClientId: z.optional(z.string()),
      trustedRemoteSessionIssuerId: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        authnChallengeMode: "authn_challenge_mode",
        clientIdMetadataAdmissionMode: "client_id_metadata_admission_mode",
        sessionDurationHours: "session_duration_hours",
        trustedRemoteSessionClientId: "trusted_remote_session_client_id",
        trustedRemoteSessionIssuerId: "trusted_remote_session_issuer_id",
      });
    }),
  );

export function updateOrganizationUserSessionIssuerFormToJSON(
  updateOrganizationUserSessionIssuerForm:
    UpdateOrganizationUserSessionIssuerForm,
): string {
  return JSON.stringify(
    UpdateOrganizationUserSessionIssuerForm$outboundSchema.parse(
      updateOrganizationUserSessionIssuerForm,
    ),
  );
}
